export default __webpack_public_path__ + "b946e1a102fc93510e86186b7f7b0c0b.png";